import { render, staticRenderFns } from "./lw-chart.vue?vue&type=template&id=4308e390&scoped=true&"
import script from "./lw-chart.vue?vue&type=script&lang=js&"
export * from "./lw-chart.vue?vue&type=script&lang=js&"
import style0 from "./lw-chart.vue?vue&type=style&index=0&id=4308e390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308e390",
  null
  
)

export default component.exports